import { render, staticRenderFns } from "./user_menu_explore_premium.vue.js?vue&type=template&id=95d32dba!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./user_menu_explore_premium.vue?vue&type=template&id=95d32dba"
import script from "./user_menu_explore_premium.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./user_menu_explore_premium.vue?vue&type=script&lang=js"
export * from "./user_menu_explore_premium.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./user_menu_explore_premium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95d32dba')) {
      api.createRecord('95d32dba', component.options)
    } else {
      api.reload('95d32dba', component.options)
    }
    module.hot.accept("./user_menu_explore_premium.vue.js?vue&type=template&id=95d32dba!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./user_menu_explore_premium.vue?vue&type=template&id=95d32dba", function () {
      api.rerender('95d32dba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ee/app/assets/javascripts/super_sidebar/components/user_menu_explore_premium.vue"
export default component.exports